import React from 'react';
import GrammarViewer from '../common/grammarViewer/GrammarViewer';

function WorksheetItem({ item, index }) {

  if (!item) return <></>
  return (
    <li className='lstMath'>
      <span className="num">{index}</span>
      {/* <!-- 이 className="mathExp_box" div 안에 문항 수식 (메쓰젝스)를 넣어 주세요 --> */}
      <div className="mathExp_box">
        <div className="calcEdit-viewer_inner">
          <table className="tbl-multiple">
            <colgroup>
              <col style={{ minWidth: '40px' }} />
              <col style={{ minWidth: '40px' }} />
            </colgroup>
            <tbody>
              <tr>
                <td>
                  <GrammarViewer>
                    {item.qstCn}
                  </GrammarViewer>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </li>
  );
}

export default WorksheetItem;